import * as React from 'react';
import s from './Seperator.scss';

export const Seperator = () => <div className={s.seperator} />;
